import { gql } from "@apollo/client";

export const GET_PRODUCT_QUERY = gql`
query GetProduct($brand: String!, $sk: String!) {
  getProduct(brand: $brand, sk: $sk) {
      brandName
      createdAt
      description
      discipline
      discount
      gallery
      isArchived
      newOrUsed
      photo
      pk
      price
      productTitle
      quantity
      saddlefitSku
      scannedFiles
      score
      size
      sk
      status
      type
      updatedAt
      userId
      variantId
          measurements {
        barAngle
        gulletHeight
        gulletWidth
        swayHeight
      }
    }
  }
`;
